import { mutationTypes } from './mutationUtils';

export const coloredMutationTypesRef = {
  [ mutationTypes.SOFT ]: { h: 360, s: 0.62, l: 0.74 },
  [ mutationTypes.HARD ]: { h: 200, s: 0.5, l: 0.74 },
  [ mutationTypes.MIXED ]: { h: 270, s: 1, l: 0.74 },
  [ mutationTypes.SPIRANTE ]: { h: 120, s: 0.55, l: 0.74 },
};

export const coloredMutationTypes = Object.keys(coloredMutationTypesRef);
